import { MenuItem, Select } from "@mui/material";
import { useIsCredentialRequirementConfigurationEnabled } from "@src/appV2/FeatureFlags/useIsCredentialRequirementConfigurationEnabled";
import { FormFieldController } from "@src/appV2/PlacementCandidates/components/FormFieldController";
import { type Control, type UseFormSetValue, useWatch } from "react-hook-form";

import { isAllowRequiredForBooking } from "../isAllowRequiredForBooking";
import { MappingLevel, type RequirementMappingFormValues } from "../types";

interface LevelSelectFieldProps {
  hcfId?: string;
  control: Control<RequirementMappingFormValues>;
  setValue: UseFormSetValue<RequirementMappingFormValues>;
}

export function LevelSelectField(props: LevelSelectFieldProps) {
  const { hcfId, control, setValue } = props;

  const isCredentialRequirementConfigurationEnabled =
    useIsCredentialRequirementConfigurationEnabled();

  const levelOptions = [
    { value: MappingLevel.GLOBAL, label: "Global" },
    { value: MappingLevel.STATE, label: "State" },
    { value: MappingLevel.COUNTY, label: "County" },
    { value: MappingLevel.MSA, label: "MSA" },
    { value: MappingLevel.HCF, label: "HCF" },
  ];

  const domain = useWatch({ control, name: "domain" });

  return (
    <FormFieldController
      name="level"
      control={control}
      label="Level"
      sx={{ mb: 2 }}
      render={(field) => (
        <Select
          {...field}
          labelId="level-select-label"
          // FIXME: Automatically disabled during ESLint config update
          disabled={Boolean(hcfId)}
          value={field.value}
          onChange={(event) => {
            field.onChange(event);

            if (
              !isAllowRequiredForBooking({
                domain,
                mappingLevel: event.target.value as MappingLevel,
                isCredentialRequirementConfigurationEnabled,
              })
            ) {
              setValue("requiredForBooking", false);
            }
          }}
        >
          {levelOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      )}
    />
  );
}
